
<div #dashboardDiv class="dashboard-grid" [attr.data-table-ready]="ready ? 'true' : null">
    @for (widget of showingWidgets; track widget.code) {
        <div [style.gridRow]="'span ' + widget.heightWeight" [style.gridColumn]="'span ' + widget.widthWeight">
            <app-dashboard-widget
              [availCharts]="allWidgets"
              [chosenWidget]="widget"
              (updateSettings)="configureWidget($event)">
            </app-dashboard-widget>
        </div>
    }
</div>


